import React from 'react';
import { TESTIMONIALS_DATA } from '../constants';
import { Star } from 'lucide-react';

const Rating: React.FC<{ value: number }> = ({ value }) => (
  <div className="flex">
    {[...Array(5)].map((_, i) => (
      <Star key={i} className={`w-5 h-5 ${i < value ? 'text-yellow-400' : 'text-gray-300'}`} />
    ))}
  </div>
);

const Testimonials: React.FC = () => {
  return (
    <section id="testimonials" className="py-20 bg-white dark:bg-gray-950">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-secondary dark:text-white">Opiniones de Nuestros Pacientes</h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 mt-4 max-w-2xl mx-auto">
            La confianza y satisfacción de nuestros pacientes es nuestra mayor recompensa.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {TESTIMONIALS_DATA.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 dark:bg-gray-800 p-8 rounded-lg shadow-lg">
              <div className="flex items-center mb-4">
                <Rating value={testimonial.rating} />
              </div>
              <blockquote className="text-gray-700 dark:text-gray-200 italic text-lg mb-6">
                “{testimonial.quote}”
              </blockquote>
              <footer className="font-semibold text-secondary dark:text-white">
                {testimonial.author}, {testimonial.age} años
                <span className="block text-sm font-normal text-gray-500 dark:text-gray-400">
                  Paciente de {testimonial.specialty}
                </span>
              </footer>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;